import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import useReceiptsTheme from 'api/useReceiptsTheme';

import { defaultReceiptTheme } from './defaults';

export const useGetReceiptInitialValues = () => {
  const { publisherId } = useParams();

  const [initialValues, setInitialValue] = useState(defaultReceiptTheme);

  const { getReceiptTheme } = useReceiptsTheme(publisherId);

  useEffect(() => {
    const receiptTheme = getReceiptTheme?.data?.receiptTheme;
    setInitialValue({
      senderName: receiptTheme?.senderName || '',
      logo: receiptTheme?.logo || defaultReceiptTheme.logo,
      headerImage: receiptTheme?.headerImage || '',
      publisherId: publisherId || '',
      addFooter:
        typeof receiptTheme?.addFooter === 'boolean'
          ? receiptTheme.addFooter
          : Boolean(
              (receiptTheme?.companyAddressStructured?.line1 ||
                receiptTheme?.companyAddressStructured?.line2 ||
                receiptTheme?.companyAddressStructured?.line3 ||
                receiptTheme?.termsOfServiceUrl ||
                receiptTheme?.privacyPolicyUrl ||
                receiptTheme?.supportUrl) ??
                false
            ),
      paymentReceiptTemplateName:
        receiptTheme?.paymentReceiptTemplateName || '',
      refundReceiptTemplateName: receiptTheme?.refundReceiptTemplateName || '',
      subscriptionReceiptTemplateName:
        receiptTheme?.subscriptionReceiptTemplateName || '',
      subscriptionRefundReceiptTemplateName:
        receiptTheme?.subscriptionRefundReceiptTemplateName || '',
      supportUrl: receiptTheme?.supportUrl || null,
      companyAddressStructured: {
        line1:
          receiptTheme?.companyAddressStructured?.line1 ||
          defaultReceiptTheme.companyAddressStructured?.line1 ||
          '',
        line2:
          receiptTheme?.companyAddressStructured?.line2 ||
          defaultReceiptTheme.companyAddressStructured?.line2 ||
          '',
        line3:
          receiptTheme?.companyAddressStructured?.line3 ||
          defaultReceiptTheme.companyAddressStructured?.line3 ||
          ''
      },
      privacyPolicyUrl:
        receiptTheme?.privacyPolicyUrl ||
        defaultReceiptTheme.privacyPolicyUrl ||
        '',
      termsOfServiceUrl:
        receiptTheme?.termsOfServiceUrl ||
        defaultReceiptTheme.termsOfServiceUrl ||
        undefined
    });
  }, [getReceiptTheme?.data?.receiptTheme]);

  return { initialValues: initialValues || defaultReceiptTheme };
};
